// src/components/DonationForm.jsx
import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const DonationForm = () => {
  const [name, setName] = useState('');
  const [anonymous, setAnonymous] = useState(false);
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setSubmitting(true);
    try {
      await addDoc(collection(db, "guestbook"), {
        name: anonymous ? "Anonymous" : name.trim(),
        isAnonymous: anonymous,
        message: message.trim(),
        timestamp: serverTimestamp(),
      });
      setSuccess('Thank you for your message!');
      setName('');
      setAnonymous(false);
      setMessage('');
      setTimeout(() => setSuccess(''), 2200);
    } catch (err) {
      setSuccess('Sorry, something went wrong.');
      setTimeout(() => setSuccess(''), 2200);
    }
    setSubmitting(false);
  };

  return (
    <form className="guestbook-form" onSubmit={handleSubmit} autoComplete="off">
      <label htmlFor="name">Your Name</label>
      <input
        id="name"
        type="text"
        placeholder="Enter your name"
        value={name}
        onChange={e => setName(e.target.value)}
        disabled={anonymous}
        required={!anonymous}
        autoComplete="off"
      />

      <label style={{ display: 'flex', alignItems: 'center', fontWeight: 600, color: "#6d3dc6" }}>
        <input
          type="checkbox"
          checked={anonymous}
          onChange={e => setAnonymous(e.target.checked)}
          style={{ marginRight: 8 }}
        />
        Post as anonymous
      </label>

      <div className="guestbook-message-group">
        <label htmlFor="message" className="guestbook-message-label">
          Message to the family
        </label>
        <textarea
          id="message"
          placeholder="Share a memory, tribute, or message of support"
          value={message}
          onChange={e => setMessage(e.target.value)}
          required
        />
      </div>

      <button type="submit" disabled={submitting}>
        {submitting ? 'Submitting...' : 'Submit'}
      </button>
      {success && <div style={{ marginTop: 10, textAlign: 'center', color: '#7c53c3' }}>{success}</div>}
    </form>
  );
};

export default DonationForm;
